export * from '@/shared/components/data-visualization/global-trade/model';
